var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.304688 149 L 188 149 L 188 309.394531 L 6.304688 309.394531 Z M 6.304688 149 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187 65.644531 L 368.554688 65.644531 L 368.554688 226 L 187 226 Z M 187 65.644531 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#07a5c3",
    d: "M 128.28125 262.699219 L 128.28125 284.761719 L 28.425781 238.34375 L 28.425781 220.441406 L 128.28125 174.023438 L 128.28125 196.089844 L 52.765625 229.183594 L 52.765625 229.601562 Z M 187.582031 149.507812 L 20.59375 149.507812 C 12.710938 149.507812 6.320312 155.902344 6.320312 163.792969 L 6.320312 294.996094 C 6.320312 302.882812 12.710938 309.277344 20.59375 309.277344 L 141.226562 309.277344 L 187.582031 149.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6e7d8",
    d: "M 346.472656 155.183594 L 246.617188 200.976562 L 246.617188 178.910156 L 323.796875 145.816406 L 323.796875 145.398438 L 246.617188 112.300781 L 246.617188 90.238281 L 346.472656 136.03125 Z M 233.945312 65.722656 L 187.582031 225.492188 L 354.304688 225.492188 C 362.1875 225.492188 368.578125 219.097656 368.578125 211.207031 L 368.578125 80.003906 C 368.578125 72.117188 362.1875 65.722656 354.304688 65.722656 L 233.945312 65.722656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.b4eeb783852b41cadfe374dc4e6b52af.svg";
export { ForwardRef as ReactComponent };